import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { Route, RouteFilters } from '@models/route'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import routesApi from './actions'
import { routesKeys } from './constants'

interface UseRoutesData {
  routes: Route[]
  routesMap: Map<number, Route>
  pagination: PaginationMeta
}

export const selectData = ({
  data,
  pagination,
}: PaginatedResponse<Route>): UseRoutesData => ({
  routes: data,
  routesMap: new Map(data.map(route => [route.id, route])),
  pagination,
})

const useRoutes = (filters: RouteFilters) => {
  const query = useQuery<PaginatedResponse<Route>, AxiosError, UseRoutesData>(
    routesKeys.list(filters),
    () => routesApi.getRoutes(filters),
    {
      select: selectData,
      enabled: !!filters.companyId,
    },
  )

  return query
}

export default useRoutes
